import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import PriceInputUI from '../../input/PriceInputUI';
import { formatCurrency } from '../../../utils/formatters';

const DecisionControls = ({
  decision,
  rejectionReason,
  usageFee,
  calculatedRefund,
  currency,
  pendingReturnItems,
  refundFundPaymentCompleted,
  refundAmountToPay,
  onDecisionChange,
  onRejectionReasonChange,
  onUsageFeeChange
}) => {
  const handleApproveToggle = () => {
    onDecisionChange('approve');
  };

  const handleRejectToggle = () => {
    onDecisionChange('reject');
  };

  return (
    <div className="border border-gray-200 rounded-lg p-6 bg-white shadow-sm">
      <h2 className="text-lg font-medium text-gray-900 mb-4">
        Decision for all {pendingReturnItems.length} item{pendingReturnItems.length !== 1 ? 's' : ''}
      </h2>
      
      <div className="flex items-center gap-8 mb-6">
        <div className="flex items-center">
          <Checkbox
            radio
            label={<label className="font-medium text-green-700">Approve Return</label>}
            name="decisionRadioGroup"
            checked={decision === 'approve'}
            onChange={handleApproveToggle}
          />
        </div>

        <div className="flex items-center">
          <Checkbox
            radio
            label={<label className="font-medium text-red-700">Reject Return</label>}
            name="decisionRadioGroup"
            checked={decision === 'reject'}
            onChange={handleRejectToggle}
          />
        </div>
      </div>

      {decision === 'reject' && (
        <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
          <label className="block text-md font-medium text-gray-700 mb-2">
            Rejection reason (optional)
          </label>
          <textarea
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
            rows={3}
            placeholder="Provide rejection reason for all items (optional)"
            value={rejectionReason}
            onChange={onRejectionReasonChange}
          />
          
          {/* Payment refund warning */}
          {refundFundPaymentCompleted && refundAmountToPay > 0 && (
            <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
              <div className="flex items-start">
                <ExclamationTriangleIcon className="h-4 w-4 text-yellow-500 mt-0.5 mr-2 flex-shrink-0" />
                <div className="text-sm text-yellow-800">
                  <p className="font-medium">Automatic Refund</p>
                  <p>Since you've already paid {formatCurrency(refundAmountToPay, currency)}, this amount will be automatically refunded to you when you reject this return.</p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {decision === 'approve' && (
        <div className="space-y-4">
          

          <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
            <label className="block text-md font-medium text-gray-900 mb-3">Usage fee to charge customer</label>
            {refundFundPaymentCompleted && (
              <div className="mb-2 p-2 bg-green-50 border border-green-200 rounded-md">
                <p className="text-sm text-green-800">
                  <strong>Usage fee locked:</strong> {formatCurrency(parseFloat(usageFee) || 0, currency)} - Cannot be changed after payment completion
                </p>
              </div>
            )}
            <div className="max-w-xs">
              <PriceInputUI
                name="usageFee"
                value={usageFee}
                onChange={onUsageFeeChange}
                onCurrencyChange={() => {}}
                currency={currency}
                required={false}
                disableCurrencyChange={true}
                disabled={refundFundPaymentCompleted}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DecisionControls; 